import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const FarmOriginModule = ({ farmId, farmName, farmLocation, className }) => {
  return (
    <div className={cn("bg-secondary/50 rounded-xl p-5 border border-border", className)}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
            Farm of Origin
          </span>
          <h3 className="font-display text-lg font-semibold text-foreground mt-1">
            {farmName}
          </h3>
          <div className="flex items-center gap-1.5 mt-2 text-sm text-muted-foreground">
            <MapPin className="h-4 w-4" />
            <span>{farmLocation}</span>
          </div>
        </div>
        <Button asChild variant="outline" size="sm" className="shrink-0 gap-1">
          <Link to={`/farm-stories/${farmId}`}>
            Meet the farm
            <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </Button>
      </div>
    </div>
  );
};
